var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 15.25L13.9596 10.7917C13.293 10.4583 12.5013 10.9167 12.5013 11.6667V20.3333C12.5013 21.125 13.293 21.5833 13.9596 21.2083L21.293 17C22.0013 16.625 22.0013 15.6667 21.293 15.25ZM26.8346 16C26.8346 10.2917 22.2096 5.66667 16.5013 5.66667C10.793 5.66667 6.16797 10.2917 6.16797 16C6.16797 21.7083 10.793 26.3333 16.5013 26.3333C22.2096 26.3333 26.8346 21.7083 26.8346 16ZM8.16797 16C8.16797 11.4167 11.8763 7.66667 16.5013 7.66667C21.0846 7.66667 24.8346 11.4167 24.8346 16C24.8346 20.625 21.0846 24.3333 16.5013 24.3333C11.8763 24.3333 8.16797 20.625 8.16797 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a7b04ec7a5d429deec82b544686244f7.svg";
export { ForwardRef as ReactComponent };